export default __webpack_public_path__ + "static/37-60b05080f6d694e3a733c47917d33c74.png";